import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

type SectionHeaderProps = {
  title: string;
  subtitle?: string;
  eyebrow?: string;
  actionLabel?: string;
  actionTo?: string;
  align?: 'left' | 'center';
};

export function SectionHeader({
  title,
  subtitle,
  eyebrow,
  actionLabel,
  actionTo,
  align = 'left',
}: SectionHeaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: align === 'center' ? 'center' : { xs: 'flex-start', sm: 'flex-end' },
        justifyContent: 'space-between',
        gap: 2,
        mb: { xs: 4, md: 6 },
        textAlign: align,
      }}
    >
      <Box sx={{ maxWidth: align === 'center' ? 640 : 560 }}>
        {eyebrow && (
          <>
            <Typography
              variant="overline"
              sx={{
                display: 'block',
                color: 'secondary.dark',
                mb: 0.5,
              }}
            >
              {eyebrow}
            </Typography>
            <Box
              sx={{
                width: 28,
                height: 2.5,
                bgcolor: 'secondary.main',
                borderRadius: '2px',
                mb: 1.25,
                mx: align === 'center' ? 'auto' : 0,
              }}
            />
          </>
        )}
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2rem', md: '2.625rem' },
            mb: subtitle ? 1.25 : 0,
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.7, maxWidth: 560 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actionLabel && actionTo && (
        <Typography
          component={RouterLink}
          to={actionTo}
          sx={{
            color: 'primary.main',
            fontWeight: 600,
            fontSize: '0.875rem',
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            px: 2.5,
            py: 1,
            borderRadius: 'var(--radius-pill)',
            border: '1.5px solid',
            borderColor: 'primary.main',
            transition: 'background-color 250ms ease, color 250ms ease',
            '&:hover': {
              bgcolor: 'primary.main',
              color: 'common.white',
            },
          }}
        >
          {actionLabel}
        </Typography>
      )}
    </Box>
  );
}
